export const BRANDS_ARRAY = [
  ["Alfa romeo", "alfa-romeo"],
  ["Audi", "audi"],
  ["BMW", "bmw"],
  ["Citroen", "citroen"],
  ["Cupra", "cupra"],
  ["Dacia", "dacia"],
  ["Fiat", "fiat"],
  ["Ford", "ford"],
  ["Hyundai", "hyundai"],
  ["Isuzu", "isuzu"],
  ["Jaguar", "jaguar"],
  ["Kia", "kia"],
  ["Land Rover", "land-rover"],
  ["Lexus", "lexus"],
  ["Mazda", "mazda"],
  ["Mercedes-Benz", "mercedes-benz"],
  ["Honda", "honda"],
  ["Lamborghini", "lamborghini"],
  ["Nissan", "nissan"],
  ["Maserati", "maserati"],
  ["MINI", "mini"],
  ["Opel", "opel"],
  ["Peugeot", "peugeot"],
  ["Porsche", "porsche"],
  ["Renault", "renault"],
  ["Seat", "seat"],
  ["Skoda", "skoda"],
  ["Smart", "smart"],
  ["Suzuki", "suzuki"],
  ["Toyota", "toyota"],
  ["Volkswagen", "volkswagen"],
  ["Volvo", "volvo"],
  ["Iveco", "iveco"],
  ["Jeep", "jeep"],
  ["Abarth", "abarth"],
  ["Aixam", "aixam"],
  ["Alpine", "alpine"],
  ["Aston Martin", "aston-martin"],
  ["Bentley", "bentley"],
  ["BMW Alpina", "alpina"],
  ["Buick", "buick"],
  ["Cadillac", "cadillac"],
  ["Chevrolet", "chevrolet"],
  ["Chrysler", "chrysler"],
  ["Daewoo", "daewoo"],
  ["Dodge", "dodge"],
  ["DS Automobiles", "ds-automobiles"],
  ["Ferrari", "ferrari"],
  ["Hummer", "hummer"],
  ["Infiniti", "infiniti"],
  ["Lancia", "lancia"],
  ["Maybach", "maybach"],
  ["McLaren", "mclaren"],
  ["Mitsubishi", "mitsubishi"],
  ["RAM", "ram"],
  ["Rolls-Royce", "rolls-royce"],
  ["Saab", "saab"],
  ["SsangYong", "ssangyong"],
  ["Subaru", "subaru"],
  ["Tesla", "tesla"],
  ["MG", "mg"],
  ["Baic", "baic"],
  ["Forthing", "forthing"],
  ["Omoda", "omoda"],
  ["Jaecoo", "jaecoo"],
  ["BYD", "byd"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const BRANDS_MOTO_ARRAY = [
  ["AJP", "ajp"],
  ["AJS", "ajs"],
  ["Access", "access"],
  ["Adly", "adly"],
  ["Aeon", "aeon"],
  ["Aprilia", "aprilia"],
  ["Arctic Cat", "arctic-cat"],
  ["BMW", "bmw"],
  ["BPG Werks", "bpg-werks"],
  ["BSA", "bsa"],
  ["Bajaj", "bajaj"],
  ["Baotian", "baotian"],
  ["Barton", "barton"],
  ["Bashan", "bashan"],
  ["Benelli", "benelli"],
  ["Benzer", "benzer"],
  ["Beta", "beta"],
  ["Big Dog", "big-dog"],
  ["Bimota", "bimota"],
  ["Bombardier", "bombardier"],
  ["Buell", "buell"],
  ["CECTEK", "cectek"],
  ["CFMoto", "cf-moto"],
  ["CPI", "cpi"],
  ["CR&S", "cr-s"],
  ["CZ", "cz"],
  ["Cagiva", "cagiva"],
  ["Can-Am", "can-am"],
  ["City-bike", "city-bike"],
  ["Cobra Moto", "cobra-moto"],
  ["DKW", "dkw"],
  ["Daelim", "daelim"],
  ["Derbi", "derbi"],
  ["Diabolini", "diablo"],
  ["Dinli", "dinli"],
  ["Dniepr", "dniepr"],
  ["Ducati", "ducati"],
  ["EGL Eglmotor", "egl-eglmotor"],
  ["Eagle Motorsports", "eagle-motorsports"],
  ["FYM", "fym"],
  ["Fantic", "fantic"],
  ["Faspider", "faspider"],
  ["Ferro", "ferro"],
  ["GB Motors", "gb-motors"],
  ["Garelli", "garelli"],
  ["Gas Gas", "gas-gas"],
  ["Gateway", "gateway"],
  ["Geely", "geely"],
  ["Generic", "generic"],
  ["Gilera", "gilera"],
  ["HM", "hm"],
  ["Harley-Davidson", "harley-davidson"],
  ["Hartford", "hartford"],
  ["Hercules", "hercules"],
  ["Hero", "hero"],
  ["Honda", "honda"],
  ["Hummer", "hummer"],
  ["Husaberg", "husaberg"],
  ["Husqvarna", "husqvarna"],
  ["Hyosung", "hyosung"],
  ["IFA", "ifa"],
  ["Indian", "indian"],
  ["Italjet", "italjet"],
  ["IŻ", "iz"],
  ["JTG", "jtg"],
  ["Jawa", "jawa"],
  ["Jincheng", "jincheng"],
  ["Journeyman", "journeyman"],
  ["Junak", "junak"],
  ["KTM", "ktm"],
  ["Kawasaki", "kawasaki"],
  ["Keeway", "keeway"],
  ["Kentoya", "kentoya"],
  ["Kespor", "kespor"],
  ["Kingway", "kingway"],
  ["Kinroad", "kinroad"],
  ["Komar", "komar"],
  ["Kymco", "kymco"],
  ["LML", "lml"],
  ["Lambretta", "lambretta"],
  ["Laverda", "laverda"],
  ["Lifan", "lifan"],
  ["Linhai", "linhai"],
  ["Loncin", "loncin"],
  ["Lucky Star", "lucky-star"],
  ["MBK", "mbk"],
  ["MP Korado", "mp-korado"],
  ["MV AGUSTA", "mv-agusta"],
  ["MZ", "mz"],
  ["Malaguti", "malaguti"],
  ["Masai", "masai"],
  ["Mondial", "mondial"],
  ["Mondo Motors", "mondo-motors"],
  ["Moto Guzzi", "moto-guzzi"],
  ["Moto Magnus", "moto-magnus"],
  ["Moto Morini", "moto-morini"],
  ["Motobi", "motobi"],
  ["Motomar", "motomar"],
  ["Motorro", "motorro"],
  ["Motowell", "motowell"],
  ["Munch", "munch"],
  ["NSU", "nsu"],
  ["Norton", "norton"],
  ["Pannonia", "pannonia"],
  ["Peda", "peda"],
  ["Pegasus", "pegasus"],
  ["Peugeot", "peugeot"],
  ["Piaggio", "piaggio"],
  ["Polaris", "polaris"],
  ["Puch", "puch"],
  ["REX", "rex"],
  ["Redline", "redline"],
  ["Rieju", "rieju"],
  ["Romet", "romet"],
  ["Royal Enfield", "royal-enfield"],
  ["SHL", "shl"],
  ["SMC", "smc"],
  ["SYM", "sym"],
  ["Sachs", "sachs"],
  ["Scootworks", "scootworks"],
  ["Sherco", "sherco"],
  ["Shineray", "shineray"],
  ["Simson", "simson"],
  ["Skyjet", "skyjet"],
  ["Sokół", "sokol"],
  ["Summit", "summit"],
  ["Sunbeam", "sunbeam"],
  ["Suzuki", "suzuki"],
  ["TGB", "tgb"],
  ["TM", "tm"],
  ["Triton", "triton"],
  ["Triumph", "triumph"],
  ["Ural", "ural"],
  ["Vectrix", "vectrix"],
  ["Ventus", "ventus"],
  ["Vespa", "vespa"],
  ["Victory", "victory"],
  ["Vincent", "vincent"],
  ["WFM", "wfm"],
  ["WSK", "wsk"],
  ["X-Moto", "x-moto"],
  ["Yamaha", "yamaha"],
  ["Yuki", "yuki"],
  ["Zipp", "zipp"],
  ["Zonda", "zonda"],
  ["Zongshen", "zongshen"],
  ["Zumico", "zumico"],
  ["Zundapp", "zundapp"],
  ["Inny", "other"],
  ["Benyco", "benyco"],
  ["Benda", "benda"],
  ["KXD", "kxd"],
  ["Goes", "goes"],
  ["Stels", "stels"],
  ["SWM", "swm"],
  ["Askoll", "askoll"],
  ["Moti", "moti"],
  ["Niu", "niu"],
  ["Super Soco", "super-soco"],
  ["Orange County Choppers (OCC)", "orange-county-choppers-occ"],
  ["Triango", "triango"],
  ["KSR Moto", "ksr-moto"],
  ["Elon Motors", "elon-motors"],
  ["Yamasaki", "yamasaki"],
  ["Energica", "energica"],
  ["BOOM", "boom"],
  ["Rewaco", "rewaco"],
  ["Greenwolke", "greenwolke"],
  ["Zontes", "zontes"],
  ["E-mio", "e-mio"],
  ["FK Motors", "fk-motors"],
  ["Zero", "zero"],
  ["Surron", "surron"],
  ["Bili Coco", "bili-coco"],
  ["Bili Bike", "bili-bike"],
  ["eFun", "efun"],
  ["iamelectric", "iamelectric"],
  ["UM", "um"],
  ["Big Bear Choppers", "big-bear-choppers"],
  ["SHERP", "sherp"],
  ["Nitro Motors", "nitro-motors"],
  ["CORVUS", "corvus"],
  ["FD MOTORS", "fd-motors"],
  ["ODES", "odes"],
  ["RM", "rm"],
  ["Segway", "segway"],
  ["VELEX", "velex"],
  ["Brixton", "brixton"],
  ["Motron", "motron"],
  ["VOGE", "voge"],
  ["HISUN", "hisun"],
  ["MRF", "mrf"],
  ["KAYO", "kayo"],
  ["Alfarad", "alfarad"],
  ["ELECTRORIDE", "electroride"],
  ["Yadea", "yadea"],
  ["ASIX", "asix"],
  ["XTR", "xtr"],
  ["APOLLO", "apollo"],
  ["MIKILON", "mikilon"],
  ["TAO MOTORS", "tao-motors"],
  ["LIYA", "liya"],
  ["XMOTOS", "xmotos"],
  ["BearEbike", "bearebike"],
  ["MIR Racing", "mir-racing"],
  ["Pit Bike IMR", "pit-bike-imr"],
  ["Cross IMR", "cross-imr"],
  ["Amperi", "amperi"],
  ["Enormis", "enormis"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const findBrand = (slug: string) => {
  return BRANDS_ARRAY.concat(BRANDS_MOTO_ARRAY).find(el => el[1] === slug)
}

export const findBrandByName = (slug: string) => {
  return BRANDS_ARRAY.concat(BRANDS_MOTO_ARRAY).find(el => el[0] === slug)
}

export const translateBrand = (brand: string) => {
  const tmp = BRANDS_ARRAY.concat(BRANDS_MOTO_ARRAY).find(el => el[1] === brand)
  if (tmp) {
    return tmp[0]
  }
  return brand
}

export const translateBrandToSlug = (brand: string) => {
  const tmp = BRANDS_ARRAY.concat(BRANDS_MOTO_ARRAY).find(el => el[0] === brand)
  if (tmp) {
    return tmp[1]
  }
  return brand
}
